export class Jwt {

    protected token: string;

    public constructor(token: string) {
        this.token = token;
    }

    public getData() {
        return JSON.parse(atob(this.token.split('.')[1]));
    }

    public isExpired() {
        const data = this.getData();
        return data.exp < Math.round(Date.now() / 1000);
    }

    public toString = (): string => {
        return this.token;
    }
}
